import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  banner: {
    position: 'fixed',
    right: theme.spacing(1),
    bottom: theme.spacing(1),
    zIndex: theme.zIndex.modal + 1,
    padding: theme.spacing(0.25, 0.75),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.type === 'dark'
      ? 'rgba(255, 255, 255, 0.16)'
      : 'rgba(0, 0, 0, 0.58)',
    color: theme.palette.common.white,
    letterSpacing: '0.04em',
    pointerEvents: 'none',
  },
}));

const buildVersion = process.env.REACT_APP_BUILD_VERSION || 'local';
const buildEnvironment = process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV;

export default function VersionBanner() {
  const classes = useStyles();

  return (
    <Typography
      className={classes.banner}
      component="div"
      variant="caption"
      aria-label={`MFS Portal version ${buildVersion}, ${buildEnvironment}`}
    >
      MFS {buildEnvironment} · v{buildVersion}
    </Typography>
  );
}
